module.exports = __webpack_public_path__ + "static/media/artsozaiiwide.173db414.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/artsozaiiwide.svg
// module id = 307
// module chunks = 98